import React from "react";
import { QRCodeSVG } from 'qrcode.react';
import {Placeholder, Mask, Spin, SpinText} from './styles';

export interface QRCodeProps {
    value?: string;
    /**
     * L: LOW
     * M: MEDIUM
     * Q: QUARTILE
     * H: HIGH
     */
    level?: 'L' | 'M' | 'Q' | 'H';
    size?: number;
    includeMargin?: boolean;
    isLoading?: boolean;
    error?: React.ReactElement | string;
}
export default function QRCode({
    value,
    includeMargin,
    isLoading,
    size = 128,
    error = undefined
}: QRCodeProps) {
    // const text = `https://paygateway.niu.niuxyx.com/vippay/payment-order.html?orderNo=${paymentOrderNo}`;



    return <div style={{
        position: "relative",
        display: "inline-block",
        verticalAlign: "middle",
        //border: 1px solid #e5e5e5;
        width: size,
        height: size,
    }}>
        {value ? (
            <QRCodeSVG
                includeMargin={includeMargin}
                style={{ verticalAlign: 'middle' }}
                value={value}
                size={size}
            />
        ) : null}
        {error ? (
            <>
                <Placeholder>{error}</Placeholder>
                <Mask />
            </>
        ) : (
            isLoading ? (
                <>
                    <Placeholder>
                        <Spin />
                        <SpinText>Loading...</SpinText>
                    </Placeholder>
                    <Mask />
                </>
        ) : null)}
    </div>
}
